import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { MillisecondsInOneDay } from 'mini-datetime-utils/lib/dateValues/constants';

/**
 * This function returns the number of days between epoch start and the date user created their account.
 * Essentially it is the epoch time stamp, but in days.
 * @returns number
 */
export const getMailboxCreationDateTimestampInDays = (): number => {
    const mailBoxCreateDate = new Date(getUserConfiguration().MailboxCreateDate);
    return mailBoxCreateDate.getTime() / MillisecondsInOneDay;
};
